module.exports = __webpack_public_path__ + "img/speelmuur.6fd153f8.jpg";